export const STATE_KEY: string = 'geoLocations'
